import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { QueryParamsHandling } from '@angular/router';
import { Nullish } from '@shared/utils';
import { RouterModule } from '@angular/router';
import { TooltipModule } from '@openng/optimus-ui/tooltip';

@Component({
  selector: 'ui-page-header',
  templateUrl: './page-header.component.html',
  // hlavička stránky podle gov.cz (vzor AISK); nadpisový řádek a zpětné tlačítko jsou v utilitách šablony, kartu dává
  // .reza-card (components.css knihovny)
  host: { class: 'flex flex-col m-0' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, TooltipModule],
})
export class PageHeaderComponent {
  @Input()
  pageTitle: string | Nullish = null;

  @Input()
  pageSubtitle: string | Nullish = null;

  readonly pageTitleTooltip = input<string | null>(null);

  @Input()
  label!: string;

  @Input()
  backRouterLink: string | null = null;

  readonly backRouterLinkTooltip = input<string | null>(null);

  readonly useHistoryBackRouterLink = input(true);

  readonly navigationHistoryType = input('_');

  readonly queryParamsHandling = input<QueryParamsHandling | ''>('');

  @Input()
  pageTitleSuffix: string | null = null;

  readonly dataCy = input<string | null>(null);

  get backLinkCompleteUrl() {
    // return this._navigationService.getBackLinkUrl(this.navigationHistoryType);
    return {
      url: this.useHistoryBackRouterLink() ? null : 'url.pathname',
      queryParams: this.useHistoryBackRouterLink() ? null : {},
    };
  }
}
